<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const props = defineProps({
  // Chatwoot's own conversation "id" IS the display_id nervenet keys bills
  // on — app/views/api/v1/models/_conversation.json.jbuilder serializes
  // `json.id conversation.display_id`, so no separate lookup is needed.
  conversationDisplayId: {
    type: [Number, String],
    required: true,
  },
});

const { accountId } = useAccount();

const billUrl = computed(
  () =>
    `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}` +
    `/commerce/conversations/${props.conversationDisplayId}/bill`
);
</script>

<template>
  <div class="w-full h-full">
    <NervenetFrame :src="billUrl" />
  </div>
</template>
